<template>
  <div class="comment_pro">
    <div
      class="comment_pro_left"
      v-if="procuts_info.feature_image && procuts_info.feature_image.thumbnail"
    >
      <img
        data-sizes="auto"
        @error.once="imageFailure($event, defaultImage)"
        class="lazyload"
        :src="procuts_info.feature_image.thumbnail"
        alt=""
      />
    </div>
    <div class="comment_pro_right">
      {{ procuts_info.post_title }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["procuts_info"],
};
</script>
<style scoped lang='scss'>
.comment_pro {
  width: 100%;
  display: flex;
  padding: 25px 12px;
  align-items: center;
  border-top: solid 1px #e2e2e2;
  .comment_pro_left {
    width: 60px;
    height: 60px;
    margin-right: 17px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .comment_pro_right {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>